module.exports = __webpack_public_path__ + "static/media/flag-cy.e2513685.webp";